<gs1-footer [breakWidth]="835">
   
    <a name="footer-cgu" (click)="CGU()" angulartics2On="click" angularticsAction="CGUFooter">{{'footer.CGU' | translate}}</a>
    <a name="footer-confidentiality" (click)="PolitiqueConfidentialite()" angulartics2On="click" angularticsAction="PolitiqueConfidentialiteFooter">{{'footer.PolitiqueConfidentialite' | translate}}</a>
    <a name="footer-legal" routerLink="/mentions-legales" angulartics2On="click" angularticsAction="MentionsLegalesFooter">{{'footer.MentionsLegales' | translate}}</a>
</gs1-footer>